"use client";

import { JobPostingCardData, SchoolData } from "@nimble/candidate-api/types";
import { useCallback } from "react";

import SchoolPageJobRowView from "@/app/(discover)/jobs/[stateName]/districts/[districtId]/schools/[schoolId]/(school)/components/school-page-job-row.view";
import useJobDetailsURLDrawer from "@/components/shared/jobs/job-details-drawer/use-job-details-url-drawer";
import { StateConfig } from "@/lib/states-config";

interface SchoolPageJobRowContainerProps {
  job: JobPostingCardData;
  schoolData: SchoolData;
  stateConfig: StateConfig;
}

export default function SchoolPageJobRowContainer({
  job,
  schoolData,
  stateConfig,
}: SchoolPageJobRowContainerProps) {
  const { openJobDetailsDrawer } = useJobDetailsURLDrawer();

  const handleJobClick = useCallback(() => {
    openJobDetailsDrawer(job.uuid, schoolData.nces_id);
  }, [openJobDetailsDrawer, job.uuid, schoolData.nces_id]);

  return (
    <SchoolPageJobRowView
      job={job}
      schoolData={schoolData}
      onJobClick={handleJobClick}
      stateConfig={stateConfig}
    />
  );
}
